import SelectCollection from '@widesk-ui/components/form/SelectCollection';
import createSelect     from '@widesk-ui/tools/createSelect';
import PlaceTypeModel   from '@models/map/PlaceTypeModel';
import PlaceTypeForm    from '@/forms/services/map/PlaceTypeForm';
import { getIdFromUrn } from '@widesk-core/tools/identifier';

const Select = createSelect<typeof PlaceTypeModel, {
	projectUrn: Urn;
}>(props => (
	<SelectCollection
		modelClass={PlaceTypeModel}
		renderOption={m => m.renderName()}
		sortName="label"
		sortWay="asc"
		filters={{ project: getIdFromUrn(props.projectUrn) }}
		// Pas de création en ligne : `SelectCollection` l'ouvrirait dans une modale, alors que cet
		// éditeur passe par ses sidebars. Le chemin de création est offert par `PlaceForm`, sous le
		// sélecteur, et remplace le contenu du panneau.
		formAddEnabled={false}
		formEditEnabled={false}
		renderForm={formProps => (
			<PlaceTypeForm
				{...formProps}
				disableContinueAfterSubmit
				projectUrn={props.projectUrn}
			/>
		)}

		{...props}
	/>
));

export default Select;
